export class CreateDraftCashSettlementResponse {
  code?: string;
  message?: string;
  translateKey?: string;
  error?: CreateDraftCashSettlementError;
  cashSettlementNo?: string;
  saleScheduleDate?: string;
  status?: string;
  transferAmount?: number;
  totalSalesInCash?: number;
  refundInCash?: number;
  sumStoreExpenseAmount?: number;
  sumRejectedStoreExpenseAmount?: number;
  sumOtherIncomeAmount?: number;
  otherIncomes?: otherIncomes[];
  cashOver?: number;
  previousAccumulatedSmallChange?: number;
  totalAmount?: number;
  accumulatedSmallChange?: number;
  closedStoreInfos?: CashSettlementClosedStoreInfos[];
  pendingCashSettlement?: CashSettlementPending;
}

export class otherIncomes {
  sequenceNo: string;
  name: string;
  incomeAmount: number;
}

export class CreateDraftCashSettlementError {
  saleScheduleDate?: string;
  devices?: CreateDraftCashSettlementDeviceError[];
}

export class CreateDraftCashSettlementDeviceError {
  deviceNo?: string;
  message?: string;
}

export class CashSettlementClosedStoreInfos {
  deviceNo: string;
  totalSalesInCash: number;
  refundInCash: number;
  cashOver: number;
  employeeName: string;
  closingDateTime: string;
  closeShiftBy: string;
  shiftTotalAmount: number;
  latestDeviceId: string;
  totalShifts: number;
  storeExpenseAmount: number;
}

export class CashSettlementPending {
  startDate: string;
  endDate: string;
}

export class CreateDraftCashSettlementRequest extends CreateDraftCashSettlementResponse {
  cashOverEditReason?: string;
  currentDateTime?: Date;
  transferMethod?: string;
  confirmedBy?: string;
}

export let CashSettlementDraftErrorCode: string[];
CashSettlementDraftErrorCode = [
  'CE10001',
  'CE10002',
  'CE10003',
  'CE10004',
  'CE10005',
  'CE10009',
  'CE10011',
  'CE10014'
];

export let CashSettlementTransferEvidenceErrorCode: string[];
CashSettlementTransferEvidenceErrorCode = ['CE10005', 'CE10006', 'CE10007'];
